import { render, staticRenderFns } from "./reserva.vue?vue&type=template&id=3d1d1db7"
import script from "./reserva.vue?vue&type=script&lang=js"
export * from "./reserva.vue?vue&type=script&lang=js"
import style0 from "./reserva.vue?vue&type=style&index=0&id=3d1d1db7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports